"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedVariantList = instanceOfPaginatedVariantList;
exports.PaginatedVariantListFromJSON = PaginatedVariantListFromJSON;
exports.PaginatedVariantListFromJSONTyped = PaginatedVariantListFromJSONTyped;
exports.PaginatedVariantListToJSON = PaginatedVariantListToJSON;
exports.PaginatedVariantListToJSONTyped = PaginatedVariantListToJSONTyped;
const variant_1 = require("./variant");
/**
 * Check if a given object implements the PaginatedVariantList interface.
 */
function instanceOfPaginatedVariantList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedVariantListFromJSON(json) {
    return PaginatedVariantListFromJSONTyped(json, false);
}
function PaginatedVariantListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(variant_1.VariantFromJSON)),
    };
}
function PaginatedVariantListToJSON(json) {
    return PaginatedVariantListToJSONTyped(json, false);
}
function PaginatedVariantListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(variant_1.VariantToJSON)),
    };
}
//# sourceMappingURL=paginatedVariantList.js.map